
import { useState, useEffect, useContext } from "react";
import { Row, Col, Breadcrumb, Badge, Dropdown, Button, Input, Image, Form, Modal } from "antd";
import useRequest from "../../hooks/useRequest";
import { AuthContext } from "../../context/AuthContext";
import { KeyOutlined, LogoutOutlined, UserOutlined, QuestionCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import { NavLink } from "react-router-dom";
import notfound from "../../assets/images/no-img.png";
import FileUpload from "../FileUpload";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name, onPress }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const [visible, setVisible] = useState(false);

  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState(name?.split('/') ?? []);
  const { confirm } = Modal;
  const { request } = useRequest()
  const [refresh, setRefresh] = useState(false)
  const { logout } = useContext(AuthContext)
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const items = [
    {
      label: 'Edit Profile',
      key: '1',
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: 'Change Password',
      key: '2',
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: 'Logout',
      key: '3',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: 'Logout',
        okType: 'danger',
        icon: <QuestionCircleFilled />,
        cancelText: 'Cancel',
        content: <Button >Are you sure you want to logout ?</Button>,
        zIndex: 1000,
        onOk() {
          logout();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  const handleMenuClick = (e) => {
    if (e.key == 2) {
      setVisible(true)
    }
    if (e.key == 1) {
      setProfileVisible(true)
    }
    if (e.key == 3) {
      showDeleteConfirm()
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values
    const payload = {}
    if (!old_password || !new_password) return ShowToast('Please enter password ', Severty.ERROR)
    setLoading(true)
    payload.new_password = new_password
    payload.old_password = old_password
    request({
      url: apiPath.changePassword,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          setVisible(false)
          logout()
        } else {
          ShowToast(data.message, Severty.ERROR)

        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };

  useEffect(() => {
    setBreadcrumb(name?.split('/') ?? [])
  }, [name])

  useEffect(() => {
    request({
      url: apiPath.profile,
      method: 'GET',
      onSuccess: (data) => {
        setProfile(data.data)
        setSelected(data.data)
      },
    })
  }, [refresh])

  return (
    <>

      <Row gutter={[24, 0]}>
        <Col span={24} xs={18} md={10} className="breadcrumbMain">

          <h1 style={{ fontWeight: '600' }}>
            Welcome {profile?.user_type} <span style={{ textTransform: 'capitalize' }}> <i>{' - ' + profile?.name}</i> </span>
          </h1>

          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Home</NavLink>
            </Breadcrumb.Item>

            {
              breadcrumb.map((item, index) =>
                <Breadcrumb.Item key={item} style={{ textTransform: "capitalize" }}>
                  {item}
                </Breadcrumb.Item>
              )
            }
          </Breadcrumb>
        </Col>


        <Col span={24} xs={24} sm={14} className="text-right header-control">
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <div className="profileDropdownMain">
            <Dropdown menu={menuProps}>
              <div className="font-semibold text-right ant-dropdown-trigger ant-dropdown-open">
                <div className="userName">{profile ? profile.name : "Administrator"}</div>
                <div className="userEmail">{profile ? profile.email : "admin@noreply.com"} </div>
              </div>
            </Dropdown>
            <Image
              src={profile ? profile.image_url : notfound}
            />
          </div>
        </Col>
      </Row>

      {profileVisible && <EditProfile show={profileVisible} hide={() => { setProfileVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}

      <Modal
        open={visible}
        title="Change password"
        okText="Ok"
        onCancel={() => {
          setVisible(false);
        }}
        onOk={handleCreate}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Password"
            name="old_password"
            hasFeedback
            rules={[
              { required: true, message: "Please enter the old password!" },
            ]}
          >
            <Input.Password placeholder="Enter Old Password" />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            dependencies={['old_password']}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the new password!" },
              { pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/), message: "New password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('old_password') === value) {
                    return Promise.reject(new Error('Old password & new password must be different!'));
                  }
                  return Promise.resolve();

                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter New Password" />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirm_new_password"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the confirm password!" },
              { pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/), message: "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Confirm password & password does not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter Confirm Password" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {

  const [form]                =   Form.useForm();
  const { request }           =   useRequest()
  const [loading, setLoading] =   useState(false)
  const [image, setImage]     =   useState([]);
  const [initialImage, setInitialImage] = useState([]);
  const [imageChanged, setImageChanged] = useState(false);

  useEffect(() => {
    if (!data) return
    form.setFieldsValue({ ...data })
    
    if (data?.image) {
      const mappedImage = [{ url: data.image_url }];
      setImage(mappedImage);
      setInitialImage(mappedImage);
      setImageChanged(false);
    }
  }, [data])

  const handleFile = (data) => {
    setImage(data);
    setImageChanged(true);
  }

  const onEditProfile = (values) => {
    const formData = new FormData(); 
    
    formData.append("name", values.name);
    formData.append("email", values.email);
    
    if (imageChanged && image && image[0]?.originFileObj) {
      formData.append("image", image[0].originFileObj);
    }
    
    setLoading(true)
   
    request({
      url: apiPath.updateProfile,
      method: 'POST',
      data: formData,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          setImage([]);
          setInitialImage([]);
          setImageChanged(false);
          hide()
          refresh()
        } else {
          ShowToast(data.message, Severty.ERROR)

        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };

  const handleCancel = () => {
    setImage([]);
    setInitialImage([]);
    setImageChanged(false);
    hide();
  };

  return (
    <Modal
      open={show}
      width={750}
      title="Update Profile"
      okText="Update Profile"
      onCancel={handleCancel}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24} xs={24} sm={24} md={12}>
            <Form.Item label="Name" name="name"
              rules={[
                { required: true, message: "Please enter the name!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed" }
              ]}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={24} md={12}>
            <Form.Item
              label="Email Address (Not Editable)"
              name="email"
              rules={[
                { type: "email", message: "The input is not valid E-mail!" },
                { required: true, message: "Please enter the email!" }
              ]}
            >
              <Input placeholder="Enter Email Address" disabled />
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={24} md={10}>
            <Form.Item
              label={
                <div>
                  <span style={{ fontWeight: 600 }}>Profile Image</span>
                  <div style={{ fontSize: 14, color: "#888" }}>
                    (Accept : png, jpg, jpeg, avif, webp, svg, gif)
                  </div>
                </div>
              }
              valuePropName="value" name="image" className="mb-1"
            >
              <div className="mb-1"></div>

              <FileUpload value={image} filterType={["image"]} btnName={'Image'} onChange={(data) => handleFile(data)} multiple maxCount={1} />

            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Header;
